export default __webpack_public_path__ + "static/media/background.d8c5ccf0.jpg";